// Application bootstrap: wires host-app environment values into the shared ISD
// library configuration seam. Imported for its side effect at the entry points
// of both the server and client runtimes (root layout and Providers) so the
// library is configured before any of its consumers run.
import { configureIsdLib } from '@isd/lib/config';

import {
  GEOCODE_URL,
  GOOGLE_MAPS_API_KEY,
  ISD_DISPATCH_COMPANY_ID,
  ISHEEPDOG_COMPANY_ID,
  authCheckCloudFunction,
  firebaseConfig,
  useEmulators,
} from '@/env';

configureIsdLib({
  firebase: firebaseConfig,
  useEmulators,
  authCheckCloudFunction,
  googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  geocodeUrl: GEOCODE_URL,
  isheepdogCompanyId: ISHEEPDOG_COMPANY_ID,
  isdDispatchCompanyId: ISD_DISPATCH_COMPANY_ID,
});
